import ComingSoonPage from "../../components/ComingSoonPage";
import AppShell from '../../components/AppShell';

export default function StudySnapComingSoon() {
  return (
    <AppShell>
      <div className="lg:col-span-8 space-y-6 text-center">
    <ComingSoonPage
      appName="StudySnap AI"
      teaser="An AI-powered tool for studying with flashcards."
      imageSrc="/images/coming-soon/studysnap.png"
    />
    </div>
    </AppShell>
  );
}
